import { toDppPromotionProxyPath } from '@/data/dpp/constants';
import type { DppMemberPromotion } from '@/data/dpp/types';

const NO_PROMOTION_STATUSES = [204, 404];

export const fetchDppMemberPromotion = async (
	storeId: string,
	memberId: string
): Promise<DppMemberPromotion | null> => {
	const query = new URLSearchParams({ storeId });
	const response = await fetch(`${toDppPromotionProxyPath(memberId)}?${query}`, {
		headers: { accept: 'application/json' },
	});
	if (NO_PROMOTION_STATUSES.includes(response.status)) {
		return null;
	}
	if (!response.ok) {
		throw new Error(`dpp member promotion unavailable: ${response.status}`);
	}
	return response.json();
};
